import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { OptionsComponent } from "../components/options/options.component";

export interface IDeactiveCompoenet{
    canExit: () => Observable<boolean> | Promise<boolean> | boolean;
}

export class CanDeactivateGurdService implements CanDeactivate<IDeactiveCompoenet>{
    canDeactivate(component: IDeactiveCompoenet, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) {
        return component.canExit();
    }
}